<div class="container-fluid">
    <app-report reportId="communicationsDashboard" screen="DASHBOARDCOMMUNICATIONS"></app-report>
</div>